import { memo, useCallback, useEffect, useState } from 'react';
import ReactSelect from 'react-select';

import { useGetCommonProps } from './common';
import type { SelectOption, SelectProps } from './lib';
import { getValue } from './lib';

export const Select: FC<SelectProps> = memo((props) => {
    const { options = [], defaultValue, value } = props;
    const commonProps = useGetCommonProps(props);

    const findSelected = useCallback(
        (v): SelectOption => {
            const _value = getValue(v);
            return options?.find((o) => o?.value === _value);
        },
        [options],
    );

    const [defaultSelected] = useState<SelectOption>(findSelected(defaultValue));
    const [selected, setSelected] = useState<SelectOption>();

    useEffect(() => {
        setSelected(findSelected(value));
    }, [value, findSelected]);

    return (
        <ReactSelect
            {...commonProps}
            defaultValue={defaultSelected}
            value={selected}
            onChange={(option: SelectOption) => {
                setSelected(option);
                props.onChange?.(option?.value, option);
            }}
        />
    );
});
Select.displayName = 'Select';
